<template>
  <div
    v-if="item && item.isShow === 1 && list.length > 0"
    class="mode1-box relative"
    :class="[IsMobile ? 'IsMobile' : '']"
  >
    <div class="relative new-mode-header" :class="titleAlignmentClass">
      <div>
        <div class="title-left">
          <span class="title">{{ $utils.lang_data(lang, item.list[0] && item.list[0], "langInfoObj")?.title }}</span>
        </div>
        <!-- 副标题 -->
        <div class="title_sub" v-if="$utils.lang_data(lang, item.list[0] && item.list[0], 'langInfoObj')?.subTitle">
          {{ $utils.lang_data(lang, item.list[0] && item.list[0], "langInfoObj")?.subTitle }}
        </div>
      </div>
    </div>

    <div :class="IsMobile ? 'mt10' : 'mt20'">
      <div class="mode_amdin">
        <template v-for="(item, i) in list">
          <div
            class="mode_item"
            :class="{ 'mr-0': (i + 1) % 2 === 0 }"
            v-exposure="{ eid: item.eid, jump_value: item.jump }"
            :data-id="item.eid"
          >
            <div class="mode_imgdiv relative">
              <img
                class="mode_imgdiv_img"
                :src="require(`@/lobby_common/assets/homePage/sport/sport_bg${i % 6}.jpg`)"
                alt=""
              />
              <div class="mode_absolute">
                <div class="mode_imgcontent">
                  <div class="mode_imgcontent_top">
                    <img :src="item.firstTeamLogo" alt />
                    <span>{{ item.goalPlayer?.firstTeam }}</span>
                  </div>
                  <div class="vs">VS</div>
                  <div class="mode_imgcontent_top">
                    <img :src="item.twoTeamLogo" alt />
                    <span>{{ item.goalPlayer?.twoTeam }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="mode_content">
              <div class="font1601">{{ item.goalPlayer?.firstTeam }} VS {{ item.goalPlayer?.twoTeam }}</div>
              <div>{{ item.matchTime | time1 }} &nbsp;{{ item.matchTime | time2 }}</div>
              <div>{{ $t("Datalang.newly_last_5head") }}：</div>
              <div class="mode_record">
                <div
                  class="txt1"
                  :style="`width: ${(IsMobile ? 40 : 50) + getTxtPadding(item, 0) * (IsMobile ? 10 : 20)}px`"
                >
                  {{ getTxt(item, 0) }}
                </div>
                <div
                  class="txt2"
                  :style="`width: ${(IsMobile ? 40 : 50) + getTxtPadding(item, 1) * (IsMobile ? 10 : 20)}px`"
                >
                  {{ getTxt(item, 1) }}
                </div>
                <div
                  class="txt3"
                  :style="`width: ${(IsMobile ? 40 : 50) + getTxtPadding(item, 2) * (IsMobile ? 10 : 20)}px`"
                >
                  {{ getTxt(item, 2) }}
                </div>
              </div>
              <div>{{ $t("Datalang.newly_predict_score") }}：</div>
              <div>{{ item.scoreResult }}</div>
              <div v-if="!IsMobile">{{ $t("Datalang.newly_goal_prediction") }}：</div>
              <div v-if="!IsMobile">
                {{ item.goalPlayer?.firstTeamPlayers }},&nbsp;{{ item.goalPlayer?.twoTeamPlayers }}
              </div>
              <div class="mode_btn" @click="toGame">{{ $t("Datalang.HomePage_BTM_playnow") }}&nbsp;→</div>
            </div>
          </div>
        </template>
      </div>
      <div class="mode_btn_all" align="center">
        <div v-if="!IsMobile && isShowBtn" class="btn_all_btn" @click="loadMore">
          {{ $t("Datalang.HomePage_BTM_loadmore") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mode17 from "@/lobby_common/mixins_views/homeModule/mode17.js";
export default {
  mixins: [mode17],
  methods: {},
};
</script>
<style lang="scss" scoped>
.mode1-box {
  padding: 0 10px;
}
.mode_amdin {
  width: 100%;
  overflow: hidden;
  padding-bottom: 20px;
  .mode_item {
    display: flex;
    width: 49%;
    margin-right: 2%;
    float: left;
    position: relative;
    margin-bottom: 15px;
    @media (max-width: 768px) {
      width: 330px;
      margin-right: 10px;
    }
    @media (max-width: 768px) {
      margin-bottom: 0px;
    }
    &.mr-0 {
      margin-right: 0 !important;
    }
    .mode_imgdiv {
      color: var(--font-color-200);
      @media (max-width: 768px) {
        font-size: 12px;
      }
      .mode_imgdiv_img {
        width: 200px;
        border-radius: var(--radius-300);
        display: block;
        @media (max-width: 768px) {
          width: 130px;
        }
      }
      .mode_absolute {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 1;
        .mode_imgcontent {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          text-align: center;
          height: 100%;
          .mode_imgcontent_top {
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              width: 36px;
              margin-right: 3px;
              @media (max-width: 768px) {
                width: 20px;
              }
            }
          }
          .vs {
            font-size: 32px;
            text-align: center;
            margin: 15px 0;
            font-weight: bold;
            @media (max-width: 768px) {
              font-size: 18px;
              margin: 10px 0;
            }
          }
        }
      }
    }
    .mode_content {
      font-size: 16px;
      margin-left: 15px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      color: var(--font-color-900);
      @media (max-width: 768px) {
        font-size: 12px;
        margin-left: 5px;
      }
      .font1601 {
        color: var(--font-color-1601);
      }
      .mode_record {
        display: flex;
        color: var(--font-color-200);
        > div {
          padding: 4px 0;
          text-align: center;
        }
        .txt1 {
          background: #ed0849;
          border-radius: 6px 0 0 6px;
        }
        .txt2 {
          background: #1db903;
        }
        .txt3 {
          background: #0d89e8;
          border-radius: 0 6px 6px 0;
        }
      }
      .mode_btn {
        text-decoration: underline;
        text-underline-offset: 3px;
        padding-bottom: 3px;
        cursor: pointer;
      }
    }
  }
}
.mode_btn_all {
  .btn_all_btn {
    width: 140px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    @include buttonPrimary;
  }
}
.IsMobile {
  .mode_amdin {
    display: flex;
    overflow-x: auto;
    .mode_item {
      flex-shrink: 0;
    }
  }
}
</style>
